<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="direction.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div
            *ngIf="canUploadAtrium"
            class="field">
            <label class="font-medium">Код в "Атриуме"</label>
            <crm-input-text
              [(value)]="direction.atriumCode"
              [isError]="$any(errors?.atriumCode)"></crm-input-text>
            <small
              *ngIf="errors?.atriumCode"
              class="p-error">
              {{ errors.atriumCode | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Тип</label>
            <crm-single-select
              [options]="types"
              [(selectedItem)]="direction.type"
              [class]="errors?.type ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.type ? 'ng-invalid ng-dirty' : ''"
              [filter]="false"
              [isTemplateCombined]="true"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-type="item">
                {{ type.value | directionTypeName }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.type"
              class="p-error">
              {{ errors.type | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Вид</label>
            <crm-single-select
              [options]="kinds"
              [(selectedItem)]="direction.kind"
              (selectedItemChange)="changeKind()"
              [class]="errors?.kind ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.kind ? 'ng-invalid ng-dirty' : ''"
              [filter]="false"
              [isTemplateCombined]="true"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-kind="item">
                {{ kind.value | directionKindName }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.kind"
              class="p-error">
              {{ errors.kind | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Группа</label>
            <crm-direction-single-select
              [(selectedDirection)]="direction.parent"
              [directions]="directions"
              [groupsOnly]="true"
              [showClear]="true"
              appendTo="body"></crm-direction-single-select>
            <small
              *ngIf="errors?.parent"
              class="p-error">
              {{ errors.parent | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Пользователи</label>
            <crm-user-and-group-multi-select
              [(selectedEntities)]="directionUsers"
              [rememberSelected]="true"
              [withBots]="true"
              (selectedEntitiesChange)="onChangeUsersAndGroup()"
              appendTo="body"></crm-user-and-group-multi-select>
          </div>

          <div class="field">
            <label class="font-medium">Источник</label>
            <crm-single-select
              [options]="accountingSubTypes"
              [(selectedItem)]="direction.balanceSheetSource"
              appendTo="body"
              [styleClass]="errors?.balanceSheetSource ? 'ng-invalid ng-dirty' : ''"
              class="w-full {{ errors?.balanceSheetSource ? 'ng-invalid ng-dirty' : '' }}"
              [isTemplateCombined]="true"
              [filter]="false">
              <ng-template
                #itemTemplate
                let-type="item">
                {{ type.value | balanceSheetSourceName }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.balanceSheetSource"
              class="p-error">
              {{ errors.balanceSheetSource | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Бух. счет</label>
            <crm-accounting-account-single-select
              [(selectedAccountingAccount)]="direction.accountingAccount"
              [isError]="$any(errors?.accountingAccount)"
              appendTo="body"></crm-accounting-account-single-select>
            <small
              *ngIf="errors?.accountingAccount"
              class="p-error">
              {{ errors.accountingAccount | join }}
            </small>
          </div>

          @if (direction.accountingAccount) {
            <div class="field">
              <label class="font-medium">Субконто</label>
              <crm-direction-balance-sheet-settings-list-form
                [accountId]="direction.accountingAccount.id"
                [(settings)]="direction.balanceSheetSettings">
              </crm-direction-balance-sheet-settings-list-form>
            </div>
          }

          <div
            *ngIf="direction?.type === DirectionTypeEnum.PERCENT"
            class="field">
            <label class="font-medium required-field">Расчетная БС</label>
            <crm-direction-single-select
              [(selectedDirection)]="direction.generalDirection"
              [directions]="directions"
              appendTo="body"></crm-direction-single-select>
            <small
              *ngIf="errors?.generalDirection"
              class="p-error">
              {{ errors.generalDirection | join }}
            </small>
          </div>

          <div
            *ngIf="direction.deleted"
            class="text-right">
            <p-tag
              severity="danger"
              value="Удалена"
              styleClass="mt-2"></p-tag>
          </div>
        </div>
      </p-card>

      <div
        *ngIf="[DirectionKindEnum.EXPENSE, DirectionKindEnum.INCOME].includes($any(direction.kind))"
        class="mt-3">
        <p-card styleClass="very-compact-card p-3">
          <h3 class="m-0">Классификаторы</h3>

          <div class="p-fluid mt-3">
            <div
              *ngFor="let type of getVisibleClassificationTypes()"
              class="field">
              <label class="font-bold">{{ type.name }}:</label>
              <crm-single-select
                [options]="getCategoriesForType(type)"
                [selectedItem]="getSelectedCategoryForType(type.id)"
                (selectedItemChange)="setSelectedCategoryForType(type, $event)"
                [filter]="false"
                [isTemplateCombined]="true"
                [showClear]="true"
                optionLabel="name"
                appendTo="body">
                <ng-template
                  #itemTemplate
                  let-category="item">
                  {{ category?.name }}
                </ng-template>
              </crm-single-select>
            </div>
          </div>
        </p-card>
      </div>

      <div
        class="mt-3"
        *ngIf="formStoreService.getState.forms[this.index]?.isEdit">
        <crm-directory-common-history
          [entityName]="DirectoryCommonHistoryTypeEnum.DIRECTION"
          [entityId]="formStoreService.getState.forms[this.index]?.entityId"
          [apiService]="directionService">
        </crm-directory-common-history>
      </div>
    </div>
  </div>

  <div
    *ngIf="(form$ | async)?.canWrite"
    class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveDirection()"></crm-button>

      <div class="flex align-items-center gap-2">
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && !direction.deleted"
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deleteDirection()"></crm-button>
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && direction.deleted"
          icon="pi pi-undo"
          label="Восстановить"
          styleClass="p-button-info p-button-text"
          (onClick)="restoreDirection()"></crm-button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
